module.exports = __webpack_public_path__ + "media/bootstrap-icons/cup-fill-e2ce3913.svg";